<template>
  <div :class="['login-ui-alert', typeClass]" role="alert">
    <div v-if="loading" class="loader-container">
      <moon-loader :loading="loading" color="#188bf6" size="20px" />
    </div>
    <div :class="{ 'message-with-loader': loading }">
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, defineAsyncComponent } from 'vue'


const MoonLoader = defineAsyncComponent(() => import('@/pmd/components/MoonLoader.vue'))

export default defineComponent({
  name: 'LoginUIAlert',
  components: {
    MoonLoader
  },
  props: {
    type: {
      type: String,
      default: 'info',
      validator: (value: string) => ['info', 'success', 'warning', 'danger'].includes(value)
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    typeClass(): string {
      return `login-ui-alert-${this.type}`
    }
  }
})
</script>

<style scoped>
.login-ui-alert {
  padding: 12px;
  margin-bottom: 15px;
  border: 1px solid transparent;
  border-radius: 4px;
  display: flex;
  align-items: center;
}

.loader-container {
  margin-right: 10px;
}

.message-with-loader {
  flex: 1;
}

.login-ui-alert-info {
  color: #31708f;
  background-color: #d9edf7;
  border-color: #bce8f1;
}

.login-ui-alert-success {
  color: #3c763d;
  background-color: #dff0d8;
  border-color: #d6e9c6;
}

.login-ui-alert-warning {
  color: #8a6d3b;
  background-color: #fcf8e3;
  border-color: #faebcc;
}

.login-ui-alert-danger {
  color: #a94442;
  background-color: #f2dede;
  border-color: #ebccd1;
}
</style>